import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as classroomGroupActions from '../../../actions/classroom/classroomGroupActions';
import StudentGroup from './StudentGroup';
import $ from 'jquery';
import * as groupsApi from '../../../services/api/groupApi';
import * as _ from 'lodash';

class StudentGroupContainer extends React.Component {
  constructor(context, props) {
    super(context, props);
    this.studentGroups = [];
    this.findGroup = this.findGroup.bind(this);
  }

  static propTypes = {
    groups: PropTypes.array,
    classroomGroupActions: PropTypes.object
  };

  goToGroup(group) {
    const { classroomGroupActions } = this.props;
    $(`#${group.id}`).addClass('sticky cbutton--click');
    classroomGroupActions.setSelectedGroup(group);
  }

  findGroup(id) {
    const { groups } = this.props;
    const group = groups.filter(c => c.id === id)[0];
    return {
      group,
      index: groups.indexOf(group)
    };
  }

  render() {
    const { groups } = this.props;

    if (!groups) {
      return <div />;
    }

    this.studentGroups = [];
    let groupList = groups.slice(0);
    groupList.splice(0, 1);
    groupList = _.sortBy(groupList, groupsApi.getGroupName);
    groupList.forEach((group, index) =>
      this.studentGroups.push(
        <div key={index} onClick={this.goToGroup.bind(this, group)}>
          <StudentGroup group={group} findGroup={this.findGroup} />
        </div>
      )
    );

    return (
      <div className="students-groups" data-cy="studentsGroups">
        {this.studentGroups}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    groups: state.classrooms.selectedClassroom.groups
  };
}

function mapDispatchToProps(dispatch) {
  return {
    classroomGroupActions: bindActionCreators(classroomGroupActions, dispatch),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(StudentGroupContainer);
